import { apiClient } from './client'

export type ReviewDecision = 'approved' | 'rejected'

export interface Regularization {
  id: string
  user_id: string
  user_name?: string | null
  date: string
  requested_checkin?: string | null
  requested_checkout?: string | null
  reason: string
  status: string
  review_note?: string | null
  reviewer_name?: string | null
  reviewed_at?: string | null
  created_at: string
  updated_at: string
}

export interface Overtime {
  id: string
  user_id: string
  user_name?: string | null
  date: string
  hours: number | string
  reason: string
  status: string
  review_note?: string | null
  reviewer_name?: string | null
  reviewed_at?: string | null
  created_at: string
  updated_at: string
}

// Regularizations
export async function createRegularization(data: {
  date: string; requested_checkin?: string | null; requested_checkout?: string | null
  /** "HH:MM" in the employee's own timezone (alternative to the ISO datetimes). */
  checkin_time?: string | null; checkout_time?: string | null; reason: string
}): Promise<Regularization> {
  const res = await apiClient.post<Regularization>('/attendance-requests/regularizations', data)
  return res.data
}
export async function myRegularizations(): Promise<Regularization[]> {
  const res = await apiClient.get<Regularization[]>('/attendance-requests/regularizations/mine')
  return res.data
}
export async function listRegularizations(status?: string): Promise<Regularization[]> {
  const res = await apiClient.get<Regularization[]>('/attendance-requests/regularizations', { params: status ? { status } : {} })
  return res.data
}
export async function reviewRegularization(id: string, data: { status: ReviewDecision; review_note?: string }): Promise<Regularization> {
  const res = await apiClient.post<Regularization>(`/attendance-requests/regularizations/${id}/review`, data)
  return res.data
}

// Overtime
export async function createOvertime(data: { date: string; hours: number; reason: string }): Promise<Overtime> {
  const res = await apiClient.post<Overtime>('/attendance-requests/overtime', data)
  return res.data
}
export async function myOvertime(): Promise<Overtime[]> {
  const res = await apiClient.get<Overtime[]>('/attendance-requests/overtime/mine')
  return res.data
}
export async function listOvertime(status?: string): Promise<Overtime[]> {
  const res = await apiClient.get<Overtime[]>('/attendance-requests/overtime', { params: status ? { status } : {} })
  return res.data
}
export async function reviewOvertime(id: string, data: { status: ReviewDecision; review_note?: string }): Promise<Overtime> {
  const res = await apiClient.post<Overtime>(`/attendance-requests/overtime/${id}/review`, data)
  return res.data
}

export async function cancelRegularization(id: string): Promise<Regularization> {
  const res = await apiClient.post<Regularization>(`/attendance-requests/regularizations/${id}/cancel`, {})
  return res.data
}
export async function cancelOvertime(id: string): Promise<Overtime> {
  const res = await apiClient.post<Overtime>(`/attendance-requests/overtime/${id}/cancel`, {})
  return res.data
}

export function statusBadgeClass(status: string): string {
  return status === 'approved' ? 'bg-green-100 text-green-700'
    : status === 'rejected' ? 'bg-red-100 text-red-700'
    : 'bg-amber-100 text-amber-700'
}
